import React, { useEffect, useState } from 'react';
import SalaryReportsPage from './SalaryReportsPage';
import { organizationAPI } from '../lib/api';

const BLOGIC_NAME_MATCH = 'blogic';

/**
 * Default Salary Entry / Salary Reports view — automatically excludes Blogic
 * (which has its own dedicated module at /blogic-salary-entry).
 */
export default function NonBlogicSalaryEntryPage() {
  const [excludeId, setExcludeId] = useState('');
  const [resolved, setResolved] = useState(false);

  useEffect(() => {
    organizationAPI.getAll().then(res => {
      const blogic = (res.data || []).find(o =>
        (o.name || '').toLowerCase().includes(BLOGIC_NAME_MATCH)
      );
      if (blogic) setExcludeId(blogic.id);
      setResolved(true);
    }).catch(() => setResolved(true));
  }, []);

  if (!resolved) return null;
  return <SalaryReportsPage excludedOrganizationId={excludeId || null} />;
}
